<template>
    <div class="pre-login-view">
        <slot />
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        }
    }
}
</script>
<style lang="scss" scoped>
.pre-login-view {
    width: 100vw;
    height: 100vh;
    background: $view-background-alternative;
    max-height: 100vh;
    overflow: hidden;
    overflow-y: auto;
    padding: 5rem;

    &.-vod {
        background: #141414;
    }
}
@media (max-width: $mobile) {
    .pre-login-view {
        background: $container-background;
        padding: 1rem 0;
    }
}
</style>
